import { useCallback, useState } from "react";
import { getTrackAnalytics } from "../../../api";
import { TracksAnalyticsResponse } from "../types";

interface FetchArgs {
    trackIds: string[];
    startDate: Date;
    endDate: Date;
}

interface UseTrackAnalytics {
    data: TracksAnalyticsResponse | null;
    loading: boolean;
    error: string | null;
    fetch: (args: FetchArgs) => Promise<void>;
    reset: () => void;
}

export const useTrackAnalytics = (): UseTrackAnalytics => {
    const [data, setData] = useState<TracksAnalyticsResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetch = useCallback(async ({ trackIds, startDate, endDate }: FetchArgs) => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await getTrackAnalytics({ token, trackIds, startDate, endDate });
            setData(res);
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setLoading(false);
        }
    }, []);

    const reset = useCallback(() => {
        setData(null);
        setError(null);
    }, []);

    return { data, loading, error, fetch, reset };
};
